import { AfterViewInit, Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';

@Directive({
    selector: '[appFluidHeight]'
})
export class FluidHeightDirective implements AfterViewInit {

    @Input() appFluidHeight;

    private domElement: HTMLElement;

    constructor(private renderer: Renderer2,
        private elementRef: ElementRef,
        private route: Router) {
        this.domElement = this.elementRef.nativeElement as HTMLElement;
    }

    ngAfterViewInit() {
      if (['/profile/contacts', '/profile/advance-records-search',
      '/profile/family-tree'].indexOf(this.route.url) > -1) {
        setTimeout(() => {
          this.setHeight();
        },1100);
      } else {
        setTimeout(() => {
          this.setHeight();
        });
      }

    }

    private setHeight() {
        if (this.elementRef.nativeElement) {
            const height = this.elementRef.nativeElement?.parentElement?.children[0].offsetHeight;

                if (height) {
                  this.renderer.setStyle(this.domElement, 'height', 'calc(100% - ' + height+'px)');

                  if (['/profile/past-search'].indexOf(this.route.url) === -1) {
                  //sticky header margin height
                  this.renderer.setStyle(this.domElement, 'margin-top', height + 'px');
                  }
                  this.renderer.setStyle(this.domElement, 'display', 'flex');
                  this.renderer.setStyle(this.domElement, 'flex-direction', 'column');
                } else {
                  setTimeout(() => {
                            this.setHeight();
                        });
                }
        } else {
            setTimeout(() => {
                this.setHeight();
            });
        }
    }

}
